module.exports = __webpack_public_path__ + "img/54_24.8c03df1e.png";